// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes animationRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}
/* Add Animation */
@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
.__music_card {
  position: relative;
  width: 150px;
  margin-left: 0 !important;
  margin-bottom: 10px;
}
@media (max-width: 576px) {
  .__music_card {
    width: 96px;
  }
}
.__music_card .__music_Card_image {
  width: 150px;
  height: 150px;
  border-radius: 6px;
  object-fit: cover;
  cursor: pointer;
}
@media (max-width: 576px) {
  .__music_card .__music_Card_image {
    width: 96px;
    height: 96px;
  }
}
.__music_card .__options {
  display: flex;
  transition: display 0.2s;
  width: max-content;
  height: 38px;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
}
.__music_card:hover .__options {
  display: flex;
}
.__music_card .__music_card_menu {
  position: absolute !important;
  top: 50% !important;
  background: #ffffff !important;
  border-radius: 6px !important;
  padding: 5px 16px !important;
  width: max-content !important;
}
.__music_card .__music_card_menu .__music_card_menu_item {
  text-align: left;
  padding: 3px 0;
  border-bottom: 1px solid #e5e5e5;
  color: #1e1e1e;
  font-size: 16px;
}

.scroll_display_musicCard::-webkit-scrollbar {
  display: none;
  cursor: pointer !important;
}
.scroll_display_musicCard::-webkit-scrollbar-thumb {
  cursor: pointer !important;
  background: #999999 !important;
  /* Optional: just make scrollbar invisible */
}`, "",{"version":3,"sources":["webpack://./src/styles/_mixins.scss","webpack://./src/components/MusicCard/index.scss"],"names":[],"mappings":"AAGA;EACE;IACE,oBAAA;ECFF;EDIA;IACE,wBAAA;ECFF;AACF;ADKA,kBAAA;AAYA;EACE;IACE,WAAA;IACA,UAAA;ECJF;EDMA;IACE,MAAA;IACA,UAAA;ECJF;AACF;AA1BA;EACE,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;AA4BF;ADGE;ECnCF;IAOI,WAAA;EA6BF;AACF;AA3BE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AA6BJ;ADTE;ECzBA;IAQI,WAAA;IACA,YAAA;EA8BJ;AACF;AA3BE;EACE,aAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;AA6BJ;AAzBI;EACE,aAAA;AA2BN;AAvBE;EACE,6BAAA;EACA,mBAAA;EACA,8BAAA;EACA,6BAAA;EACA,4BAAA;EACA,6BAAA;AAyBJ;AAvBI;EACE,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,cAAA;EACA,eAAA;AAyBN;;AApBE;EACE,aAAA;EACA,0BAAA;AAuBJ;AApBE;EACE,0BAAA;EACA,8BAAA;EACA,4CAAA;AAsBJ","sourcesContent":["@import \"./colors.scss\";\n@import \"./breakpoints\";\n\n@keyframes animationRotate {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n/* Add Animation */\n@-webkit-keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n// Small devices\n@mixin sm {\n  @media (max-width: #{$screen-sm-max}) {\n    @content;\n  }\n}\n\n@mixin upToSm {\n  @media (min-width: #{$screen-sm-min}) {\n    @content;\n  }\n}\n\n// Medium devices\n@mixin md {\n  @media (min-width: #{$screen-md-min}) {\n    @content;\n  }\n}\n\n// Large devices\n@mixin lg {\n  @media (min-width: #{$screen-lg-min}) {\n    @content;\n  }\n}\n\n// Extra large devices\n@mixin xl {\n  @media (min-width: #{$screen-xl-min}) {\n    @content;\n  }\n}\n\n// Custom devices\n@mixin rwd($screen) {\n  @media (min-width: #{$screen}px) {\n    @content;\n  }\n}\n\n@mixin screnRange($min, $max) {\n  @media (min-width: #{$min}px) and (max-width: #{$max}px) {\n    @content;\n  }\n}\n\n@mixin screenHeightRange($min, $max) {\n  @media (min-height: #{$min}px) and (max-height: #{$max}px) {\n    @content;\n  }\n}\n","@import \"./../../styles/mixins\";\n\n.__music_card {\n  position: relative;\n  width: 150px;\n  margin-left: 0 !important;\n  margin-bottom: 10px;\n\n  @include sm {\n    width: 96px;\n  }\n\n  .__music_Card_image {\n    width: 150px;\n    height: 150px;\n    border-radius: 6px;\n    object-fit: cover;\n    cursor: pointer;\n\n    @include sm {\n      width: 96px;\n      height: 96px;\n    }\n  }\n\n  .__options {\n    display: flex;\n    transition: display 0.2s;\n    width: max-content;\n    height: 38px;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    margin: auto;\n  }\n\n  &:hover {\n    .__options {\n      display: flex;\n    }\n  }\n\n  .__music_card_menu {\n    position: absolute !important;\n    top: 50% !important;\n    background: #ffffff !important;\n    border-radius: 6px !important;\n    padding: 5px 16px !important;\n    width: max-content !important;\n\n    .__music_card_menu_item {\n      text-align: left;\n      padding: 3px 0;\n      border-bottom: 1px solid #e5e5e5;\n      color: #1e1e1e;\n      font-size: 16px;\n    }\n  }\n}\n.scroll_display_musicCard {\n  &::-webkit-scrollbar {\n    display: none;\n    cursor: pointer !important;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    cursor: pointer !important;\n    background: #999999 !important;\n    /* Optional: just make scrollbar invisible */\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
